import { HookResult, Transition, UIRouter } from "@uirouter/angular";
import { RootScope } from "../services/rootScope.service";
import { Provider, inject, provideAppInitializer, DOCUMENT } from "@angular/core";
import { OpPrimarySidebarService } from "app/components/opPrimarySidebar/opPrimarySidebar.service";
import { TrackingService } from "../services/tracking.service";

export function preloaderConfigFn(router: UIRouter) {
  router.transitionService.onStart({}, _onStartHook);
  router.transitionService.onSuccess({}, _onSuccessHook);
}

export const preloaderInitProvider = provideAppInitializer(() => {
  const $rootScope = inject(RootScope);
  const sidebar = inject(OpPrimarySidebarService);
  const document = inject(DOCUMENT);
  return _preloaderInit($rootScope, sidebar, document);
})

function _preloaderInit($rootScope: RootScope, sidebar: OpPrimarySidebarService, document: Document) {
  const largeSize = 1220;
  const theWindow = document.defaultView;
  $rootScope.largeScreen = theWindow.innerWidth >= largeSize;
  theWindow.addEventListener('resize', () => $rootScope.largeScreen = theWindow.innerWidth >= largeSize);
  sidebar.active = ($rootScope.largeScreen) ? true : false;
  $rootScope.pageLoading = true;
}

/**
 * On each transition reset global varaibles. The variables that has to be with the loading state of the App
 */
function _onStartHook(transition: Transition): HookResult {
  const $rootScope = transition.injector().get<RootScope>(RootScope);
  $rootScope.mainSearchActive = false;

  if (!$rootScope.largeScreen) {
    const sidebar = transition
      .injector()
      .get<OpPrimarySidebarService>(OpPrimarySidebarService);
    sidebar.active = false;
  }

  if (
    transition.to().data?.hidePreloader ||
    transition.options().custom?.hidePreloader
  ) {
    $rootScope.pageLoading = false;
    $rootScope.pageLoaded = true;
    return;
  }

  $rootScope.pageLoading = true;
  $rootScope.pageLoaded = false;
}

/**
 * On each transition send data to Tracking service and set loading variables
 */
function _onSuccessHook(transition: Transition): HookResult {
    const $rootScope = transition.injector().get<RootScope>(RootScope);
    const _document = transition.injector().get<Document>(DOCUMENT);
    const pageEle = _document.querySelector('#page-content');
    if (pageEle) pageEle.scroll({ top: 0, left: 0, behavior: "smooth" });
    setTimeout(() => {
      const _tracking = transition.injector().get<TrackingService>(TrackingService);
      _tracking.trackAppcuesPage();
    }, 300);
    setTimeout(() => {
        $rootScope.pageLoading = false;
        $rootScope.pageLoaded = true;
        $rootScope.appInitialized = true;
    }, 500);
}
